import React from "react"
import PropTypes from "prop-types"
import { jsonToComponents, constructOutputProps } from "utils"
import { withDataComponents } from "higher-order-components"
import HeroVideoWithTimedFramesContainer from "containers/hero-video-with-timed-frames"
import DynamicTextVideoFrameBlock from "blocks/dynamic-text-video-frame"
import HeadingVideoFrameBlock from "blocks/heading-video-frame"

const HeroVideoWithTimedFrames = ({ frames, ...props }) => (
  <HeroVideoWithTimedFramesContainer
    // This will translate `components` as json from backend to `components` as reactElements for each frame
    frames={frames.map(frameProps =>
      constructOutputProps(
        frameProps,
        [["components", "components"]],
        jsonToComponents([DynamicTextVideoFrameBlock, HeadingVideoFrameBlock]) // componentWhitelist for `components` inside frames
      ))}
    {...props} />
)

HeroVideoWithTimedFrames.propTypes = {
  frames: PropTypes.array.isRequired
}

// withDataComponent strips off the backend `name` and `props` structure and just exposes the props
export default withDataComponents({
  expectedComponent: "VideoFrameOverlayBlock",
  mapInputToOutput: [["frames", "frames"]]
})(HeroVideoWithTimedFrames)



// WEBPACK FOOTER //
// ./src/blocks/hero-video-with-timed-frames/index.jsx